import { render } from "./BalloonTwo.vue?vue&type=template&id=18b32a7a"
import script from "./BalloonTwo.vue?vue&type=script&lang=js"
export * from "./BalloonTwo.vue?vue&type=script&lang=js"

import "./BalloonTwo.vue?vue&type=style&index=0&id=18b32a7a&lang=css"
script.render = render

export default script